export const INFO_LIST = [
  '대출 상품에 따라, 선택한 판매몰의 정산 예정금 또는 최근 1년간 매출 누적액을 기준으로 대출 한도가 산정됩니다.',
  "판매몰의 정산예정금에는 '배송완료' 상태의 금액까지 포함되며, 실제 정산 금액과는 차이가 있을 수 있습니다.",
  '판매몰의 매출 데이터가 1년 미만인 경우, 월평균 매출액을 기준으로 1년치 매출로 환산하여 계산됩니다.',
  '한 개의 판매몰의 아이디가 여러 개인 경우, 개별 선택이 가능합니다.',
  '한 개의 판매몰의 데이터 제공사가 여러 곳인 경우, 개별 계산 후 대출 한도가 높은 데이터 제공사 기준으로 노출됩니다.',
];
